import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { SobreService } from "src/app/services/sobre.service";
import { obterArquivoPoliticaPrivacidade, obterArquivoPoliticaPrivacidadeFailure, obterArquivoPoliticaPrivacidadeSuccess } from "../../actions/Sobre/obter-politica-privacidade.action";

@Injectable()
export class ObterArquivoPoliticaPrivacidadeEffects {

  public obterArquivoPoliticaPrivacidade$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly SobreService: SobreService) {
    this.createEffects()
  }

  private createEffects() {
     this.obterArquivoPoliticaPrivacidade$ = createEffect(() => this.actions$.pipe(
       ofType(obterArquivoPoliticaPrivacidade),
       switchMap(() =>
         this.SobreService
           .obterArquivoPoliticaPrivacidade()
           .pipe(
             map(
               response => {
               if (response.erros != undefined && response.erros.length > 0) {
                 return obterArquivoPoliticaPrivacidadeFailure({ response })
               }
               return obterArquivoPoliticaPrivacidadeSuccess({ response })
             }),
             catchError(() => {
               return of()}
             )
           )
       )
     )
     );
   }
}